

import { 
    Container,
    Row,
    Col,
} from "react-bootstrap";
import CustomBarChart from "components/housingCompany/details/FinancialAnalysis/CustomBarChart";
import CustomLineChart from "components/housingCompany/details/FinancialAnalysis/CustomLineChart";
import FinancialAnalysisTree from "components/housingCompany/details/FinancialAnalysis/FinancialAnalysisTree";
import { useParams, useSearchParams } from "react-router-dom";


function PDFPage7(props: any) {
    const [searchParams] = useSearchParams();
    const showbtn = searchParams.get("showbtn");

    return (
        <>
            <Container fluid className="text-left page-break cu-pt-10">
                <h3 className="cu-fs-18">{props.TranslateString("Taloudellinen analyysi​ ")}​</h3>
                <Row>
                    <Col sm={8} className="my-2" style={{width: "1000px"}}>
                        <div className="d-flex flex-column">
                            <div className={showbtn !== null && showbtn === '0' ? 'fw-400 cu-bg-green text-left' : 'fw-600 cu-bg-green text-left'}>{props.TranslateString("Kuluihin (12 kk rullaava ka) suhteutettu maksuvalmius")}</div>
                            <CustomLineChart
                                data= {props?.lineChartData} 
                                showbtn={showbtn}
                            />
                        </div>
                    </Col>
                    <Col sm={8} className="my-2" style={{width: "1000px"}}>
                        <div className="d-flex flex-column">
                            <div className={showbtn !== null && showbtn === '0' ? 'fw-400 cu-bg-green text-left' : 'fw-600 cu-bg-green text-left'}>{props.TranslateString("Tuotot ja kulut")}</div>
                        <CustomBarChart
                            data= {props?.barChartData}
                            height={120}
                            showbtn={showbtn}
                            />
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col style={{paddingLeft:"10px"}}>
                        <FinancialAnalysisTree 
                            data = {props?.heirarchyData}
                            tbodyClass="cu-fs-10"
                            isExpand={true}
                            {...props}
                        />
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default PDFPage7;